export default __webpack_public_path__ + "static/media/log.806d3d61.png";